export function cssSelectorForShops() {
  return `[href^='${window.OneO.shopEnv.checkoutAppBase}/checkouts'],
          [href^='${window.OneO.shopEnv.checkoutAppBase}/live/checkouts']`
}

export function cssSelectorForData1oShopUrl() {
  return `[data-1o-shop-url^='${window.OneO.shopEnv.checkoutAppBase}/checkouts'],
          [data-1o-shop-url^='${window.OneO.shopEnv.checkoutAppBase}/live/checkouts']`
}

export function isHrefShopUrl(href) {
  return (
    href.startsWith(window.OneO.shopEnv.checkoutAppBase + "/checkouts") ||
    href.startsWith(window.OneO.shopEnv.checkoutAppBase + "/live/checkouts")
  )
}

export function track(url, eventName, timestamp = Date.now()) {
  setTimeout(() => {
    // timeout ensures body exists
    url += `${url.indexOf("#") === -1 ? "#" : "/"}`
    url += `e=${eventName}`
    url += `/r=${encodeURIComponent(document.referrer)}`
    url += `/pt=${encodeURIComponent(document.title)}`
    url += `/pu=${encodeURIComponent(window.location.href)}`
    url += `/bt=${encodeURIComponent(timestamp)}`
    url += `/tdi=${encodeURIComponent(getPageDomInteractiveTimestamp())}`
    url = url.replace("/checkouts/", "/checkouts/track/")

    var i = document.createElement("iframe")
    i.style.display = "none"
    i.src = url
    document.body.appendChild(i)
  }, 0)
}

export function getPageDomInteractiveTimestamp() {
  const navigationPerformances =
    window.performance.getEntriesByType("navigation")
  let rootEntry = navigationPerformances[0]
  if (navigationPerformances.length > 1) {
    rootEntry = navigationPerformances.find((entry) => entry.startTime === 0)
  }
  const domInteractive = (rootEntry && rootEntry.domInteractive) || 0
  return domInteractive + performance.timeOrigin
}
